<script lang="tsx">
import { Modal, Tooltip } from 'ant-design-vue'
import { defineComponent } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { LoadingOutlined } from '@ant-design/icons-vue'

const [name, bem] = createNamespace('IconBtn')
export default defineComponent({
  name,
  props: {
    danger: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tip: {
      type: String,
      default: ''
    },
    withConfirm: {
      type: Boolean,
      default: false
    },
    confirmTitle: {
      type: String,
      default: '重要提示'
    },
    confirmContent: {
      type: String,
      default: ''
    }
  },
  emits: ['confirm'],
  setup(props, { emit, slots }) {
    const confirm = () => {
      if (props.withConfirm) {
        Modal.confirm({
          title: props.confirmTitle,
          content: props.confirmContent,
          centered: true,
          onOk: () => {
            emit('confirm')
          }
        })
      } else {
        emit('confirm')
      }
    }
    const renderLoadingIcon = () => <LoadingOutlined spin />
    const renderContent = () => (
      <div onClick={confirm} class={bem({ danger: props.danger, border: props.border, disabled: props.disabled, loading: props.loading })}>
        {props.loading ? renderLoadingIcon() : slots?.default?.()}
      </div>
    )
    return () => (props.tip && !props.disabled ? <Tooltip title={props.tip}>{renderContent()}</Tooltip> : renderContent())
  }
})
</script>

<style lang="less">
.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: @border-radius-base;
  color: fade(@black, 50%);
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    color: @blue;
    background: @blue-fade;
  }

  &--border {
    border: 1px solid @border-color-base;

    &:hover {
      border-color: @blue;
      background: transparent;
    }
  }

  &--danger {
    &:hover {
      color: @red;
      background: @red-fade;
    }
  }

  &--disabled,
  &--loading {
    opacity: 0.5;
    cursor: not-allowed !important;
    pointer-events: none;
  }
}
</style>
